/**
 * Termly reliability fixes
 * - Prevent "Consent Preferences" link (href="#") from jumping to top of page
 * - Open Termly preferences more reliably (handles Termly loading races)
 *
 * This file intentionally avoids hard dependencies on Termly internals.
 */
(function () {
  'use strict';

  var PREFERENCES_TRIGGER_SELECTOR = '.termly-display-preferences';
  var OPEN_TIMEOUT_MS = 15000;
  var POLL_INTERVAL_MS = 250;

  function isFn(fn) {
    return typeof fn === 'function';
  }

  function tryOpenViaGlobals() {
    // Common Termly integration
    try {
      if (isFn(window.displayPreferenceModal)) {
        window.displayPreferenceModal();
        return true;
      }
    } catch (e) {}

    // Best-effort support for possible Termly namespace variants
    try {
      var t = window.Termly;
      if (t) {
        var candidates = [
          t.displayPreferenceModal,
          t.displayPreferences,
          t.openPreferenceCenter,
          t.openPreferences,
          t.showPreferenceCenter,
        ];
        for (var i = 0; i < candidates.length; i++) {
          var fn = candidates[i];
          if (isFn(fn)) {
            fn.call(t);
            return true;
          }
        }
      }
    } catch (e2) {}

    return false;
  }

  function tryClickTermlyInjectedControls(originalTrigger) {
    // If Termly injects its own controls, attempt to click them.
    // (Avoid clicking the original trigger to prevent recursion.)
    var selectors = [
      '#termly-code-snippet-support [data-termly-action="preferences"]',
      '#termly-code-snippet-support .termly-display-preferences',
      '#termly-consent-banner [data-termly-action="preferences"]',
      '#termly-consent-banner .termly-display-preferences',
      // Some installs may use ARIA labels/controls
      '#termly-code-snippet-support button[aria-label*="Preference"]',
      '#termly-code-snippet-support button[aria-label*="preference"]',
      '#termly-consent-banner button[aria-label*="Preference"]',
      '#termly-consent-banner button[aria-label*="preference"]',
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;
      if (el === originalTrigger) continue;
      try {
        if (isFn(el.click)) {
          el.click();
          return true;
        }
      } catch (e) {}
    }

    return false;
  }

  function openPreferencesWithRetry(originalTrigger) {
    if (tryOpenViaGlobals()) return true;
    if (tryClickTermlyInjectedControls(originalTrigger)) return true;

    // Termly can load after the visitor clicks the link.
    // Keep trying briefly while staying within the same user gesture context.
    var start = Date.now();
    var t = window.setInterval(function () {
      if (tryOpenViaGlobals() || tryClickTermlyInjectedControls(originalTrigger)) {
        window.clearInterval(t);
        return;
      }
      if (Date.now() - start > OPEN_TIMEOUT_MS) {
        window.clearInterval(t);
      }
    }, POLL_INTERVAL_MS);

    return false;
  }

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest(PREFERENCES_TRIGGER_SELECTOR);
    if (!trigger) return;

    // Prevent "#" from updating the URL hash and jumping the page.
    event.preventDefault();

    // Extra guard: preserve scroll position in case another handler changes it.
    var y = window.scrollY || window.pageYOffset || 0;

    openPreferencesWithRetry(trigger);

    // Restore scroll position if it changed (rare, but addresses reported behavior).
    window.setTimeout(function () {
      var y2 = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(y2 - y) > 24) {
        window.scrollTo(0, y);
      }
    }, 0);
  }

  function init() {
    // Capture so we can prevent default before the browser scrolls.
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
